import Root from "./Root";
import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";
import { configureReduxStore } from "./store/ApplicationStore";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href")!;
const history = createBrowserHistory({ basename: baseUrl });
export const store = configureReduxStore(history);

export type ApplicationState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

ReactDOM.render(<Root history={history} store={store} />, document.querySelector("#root"));
